import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3944cb95"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "success-page-text-div"
};
const _hoisted_2 = {
  class: "success-page-text-style",
  style: {
    "text-align": "center"
  }
};
const _hoisted_3 = {
  class: "success-page-text-style mt-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString($props.title), 1), _createElementVNode("p", _hoisted_3, _toDisplayString($props.detail), 1)]);
}